module.exports = __webpack_public_path__ + "img/order.8bf00edc.svg";